module.exports = __webpack_public_path__ + "img/rewards.b896920d.svg";